import { render } from "./card-forum.vue?vue&type=template&id=afc4aacc&ts=true"
import script from "./card-forum.vue?vue&type=script&lang=ts"
export * from "./card-forum.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__